import { Box } from '@mui/material'
import { useDispatch, useSelector } from 'react-redux'
import FormModalContainer from '../../../components/Modals/FormModalContainer'
import SortByList from '../../../components/PageHelpers/Sort'
import { selectUsersBatchActionsStatus } from '../../../redux/features/usersBatchActionsStatus/usersBatchActionsStatusSlice'
import { getFilterUsersBatchActionsStatusList, getSortUsersBatchActionsStatusList } from '../../../redux/features/usersBatchActionsStatus/usersBatchActionsStatusThunk'
import UseTranslation from '../../../hooks/UseTranslation'
import MenuListMultiSelect from '../../../components/Forms/MenuListMultiSelect'
import ActiveFilters from '../../../components/PageHelpers/ActiveFilters'
import OfoqThemeBtn from '../../../components/Buttons/OfoqThemeBtn'

const Mobile = ({
  openModal,
  setOpenModal,
}) => {
  const usersBatchActionsStatusStore = useSelector(selectUsersBatchActionsStatus)
  const dispatch = useDispatch()
  const { t } = UseTranslation()
  const handleClose = () => {
    setOpenModal(false)
  }
  const clearAllFilters = () => {
    dispatch(getFilterUsersBatchActionsStatusList({ queries: 'clear' }))
  }

  return (
    <FormModalContainer
      modalTitle={`${t?.['Filter By']}`}
      modalState={openModal}
      handleClose={handleClose}
      keepMounted
      cancelText={t?.close}
    >
      <Box sx={styles.filterBox} >
          <ActiveFilters
            store={usersBatchActionsStatusStore}
            actionToDispatch={getFilterUsersBatchActionsStatusList}
            customStyle={styles.activeFilter}
          />
        <SortByList
          actionToDispatch={getSortUsersBatchActionsStatusList}
          store={usersBatchActionsStatusStore}
        />

        <MenuListMultiSelect
            store={usersBatchActionsStatusStore}
            actionToDispatch={getFilterUsersBatchActionsStatusList}
        />
      </Box>
 <OfoqThemeBtn
        name={`${t?.['Clear Filters']}`}
         onClick={clearAllFilters}
        customStyle={styles.clearFilters}
      />
    </FormModalContainer>
  )
}

const styles = {
  filterBox: {
    display: 'flex',
    gap: { xs: '5px', md: '23px' },
    width: '100%',
    flexDirection: { xs: 'column', sm: 'row' },
    my: '20px',
  },
  firstFilter: {
    marginInline: { xs: '0px', md: '10px' },
    marginBottom: '0px',
  },
  activeFilter: {
    flexWrap: 'wrap',
  },
  clearFilters: {
    width: { xs: '100%', sm: '0px' },
    maxWidth: { xs: '100%', md: '150px' },
    minWidth: { xs: '80px', sm: '0px' },
    marginTop: { xs: '30px', sm: 'unset' },
  },
}

export default Mobile
